<script setup lang="ts">
/**
 * Small "+ ADD" action button placed above data tables. The visible text is
 * always the generic "Add" (rendered uppercase); `label` is a descriptive
 * per-entity string (e.g. "Add client") used only as `aria-label`, so the
 * intent is still accessible even without visible surrounding context.
 */
import { useI18n } from 'vue-i18n'

defineProps<{ label: string }>()
defineEmits<{ click: [] }>()

const { t } = useI18n()
</script>

<template>
  <button type="button" class="add-btn" :aria-label="label" @click="$emit('click')">
    + {{ t('common.add') }}
  </button>
</template>

<style scoped>
.add-btn {
  appearance: none;
  background: transparent;
  border: 1px solid var(--color-tufte-border);
  color: var(--color-tufte-text);
  font: inherit;
  font-size: var(--text-tufte-sm);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 0.25rem 0.7rem;
  cursor: pointer;
  border-radius: 2px;
  white-space: nowrap;
  flex-shrink: 0;
}

.add-btn:hover {
  background: color-mix(in srgb, var(--color-tufte-text) 6%, transparent);
}

.add-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 1px color-mix(in srgb, var(--color-tufte-text) 40%, transparent);
}
</style>
